import RedirectLayout from './RedirectLayout';
import redirect from './redirect';

export default function redirectPermanently(url) {
  const Redirect = redirect(url, { statusCode: 301 });

  return (
    <RedirectLayout>
      <Redirect />
    </RedirectLayout>
  );
}
